export default __webpack_public_path__ + "static/media/cap-active.ebf8417e.svg";